import(/* webpackMode: "eager" */ "/app/src/assets/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/fonts.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@18.3.1/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/client-app.js");
